<template>
  <div id="activities-tab" class="form tab-content">
    <activities-list
      v-if="currentSection === 'activitiesList'"
      :object-uuid="objectUuid"
      :object-layer="objectLayer"
      :action-type="actionType"
      @openActivity="selectedActivityUUID = $event"
      @addActivity="activityCreate = true"
    />

    <activity-create
      :object-uuid="objectUuid"
      :object-layer="objectLayer"
      :object-data="objectData"
      v-if="currentSection === 'activityCreate'"
      @close="close($event)"
    />

    <activity-details
      v-if="currentSection === 'activityDetails'"
      :activity-uuid="selectedActivityUUID"
      :action-type="actionType"
      @openTask="selectedTaskUUID = $event"
      @addTask="taskCreate = true"
      @return="returnToActivitiesList"
    />

    <task-create
      v-if="currentSection === 'taskCreate'"
      :object-layer="objectLayer"
      :activityUuid="selectedActivityUUID"
      @close="taskCreate = false"
      :objectData="objectData"
    />

    <task-details
      v-if="currentSection === 'taskDetails'"
      :taskUuid="selectedTaskUUID"
      :action-type="actionType"
      :activityUUID="selectedActivityUUID"
      @return="returnToActivityDetails"
      :width="width"
    />
  </div>
</template>

<script>
import ActivitiesList from "./ActivitiesList";
import ActivityDetails from "./ActivityDetails/ActivityDetails";
import ActivityCreate from "./ActivityCreate/ActivityCreate";
import TaskDetails from "@/components/Home/Forms/_SpecialTabs/Activities/TaskDetails/TaskDetails";
import TaskCreate from "@/components/Home/Forms/_SpecialTabs/Activities/TaskCreate/TaskCreate";

export default {
  name: "ActivitiesTab",

  components: {
    TaskCreate,
    TaskDetails,
    ActivityCreate,
    ActivityDetails,
    ActivitiesList
  },

  props: {
    objectUuid: String,
    objectLayer: String,
    actionType: String,
    width: Number,
    /**
     * receives data from
     */
    objectData: Object
  },

  data() {
    return {
      selectedActivityUUID: null,
      selectedTaskUUID: null,

      activityCreate: false,
      taskCreate: false
    };
  },

  computed: {
    /**
     * Determines which component is rendered.
     */
    currentSection() {
      if (this.selectedTaskUUID) {
        return "taskDetails";
      } else if (this.selectedActivityUUID) {
        if (!this.taskCreate) {
          return "activityDetails";
        } else {
          return "taskCreate";
        }
      } else if (this.activityCreate) {
        return "activityCreate";
      }
      return "activitiesList";
    }
  },

  methods: {
    /**
     * When a New Activity is created redirects into tasks table.
     */
    close(uuid) {
      if (uuid) {
        this.activityCreate = null;
        this.selectedActivityUUID = uuid;
      } else {
        this.selectedActivityUUID = null;
        this.activityCreate = false;
      }
    },

    /**
     * when pressing back button, returns into activities list.
     */
    returnToActivitiesList() {
      this.selectedActivityUUID = null;
    },

    /**
     * Returns to Tasks Table when pressing back button in details form
     */
    returnToActivityDetails() {
      this.selectedTaskUUID = null;
    }
  }
};
</script>

<style>
#activities-tab {
  padding: 0 30px;
  overflow: auto;
}

#activities-tab table.v-table tbody td:first-child,
#activities-tab table.v-table thead th:first-child {
  padding-left: 10px;
}

#activities-tab table.v-table tbody td:first-child,
#activities-tab table.v-table tbody td:not(:first-child),
#activities-tab table.v-table tbody th:first-child,
#activities-tab table.v-table tbody th:not(:first-child),
#activities-tab table.v-table thead td:first-child,
#activities-tab table.v-table thead td:not(:first-child),
#activities-tab table.v-table thead th:first-child,
#activities-tab table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}

#activities-tab table.v-table thead tr,
#activities-tab table.v-table tbody td,
#activities-tab table.v-table tbody th,
#activities-tab .v-datatable__actions {
  height: 40px;
}

#activities-tab .v-datatable__actions__select .v-select {
  margin: 0 0 0 34px;
}

#activities-tab .v-datatable__actions__range-controls {
  min-height: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/ActivitiesTab.vue